import Vue from 'vue'
import { LocalStorageKeys } from '@/constants/localStorage'

type StorageData = string | null

export const SynchronizedStorage = {
  _get: (key: string) => {
    return new Promise<StorageData>((resolve, reject) => {
      const data = localStorage.getItem(key)
      if (!data && window != window.parent) {
        Vue.$postMessage.addEventListener('setStorage', args => {
          console.log(args)
          if (!args.key) reject(new Error('invalid storage data'))
          if (args.key === key) {
            args.payload ? resolve(args.payload) : resolve(null)
          }
        })
        Vue.$postMessage.addEventListener('error', e => {
          console.log(e)
          reject(e)
        })
        Vue.$postMessage.getStorage(key)
      } else {
        resolve(data)
      }
    })
  },
  BleAutoSending: {
    get: async () => {
      const key = LocalStorageKeys.BLE_AUTO_SENDING
      const data = localStorage.getItem(key)
      if (data != null) return data == 'true'
      try {
        const data = await SynchronizedStorage._get(key)
        localStorage.setItem(key, String(data))
        return data == 'true'
      } catch (e) {
        return null
      }
    },
    set: async (sending: boolean) => {
      const key = LocalStorageKeys.BLE_AUTO_SENDING
      localStorage.setItem(key, String(sending))
      Vue.$postMessage.saveStorage({ key, payload: sending })
    }
  },
  MessageLastCheckedTime: {
    get: async () => {
      const key = LocalStorageKeys.CALL_CHECKED_DATETIME
      try {
        const data = await SynchronizedStorage._get(key)
        localStorage.setItem(key, String(data))
        return data
      } catch (e) {
        return null
      }
    },
    set: (timestamp: string) => {
      const key = LocalStorageKeys.CALL_CHECKED_DATETIME
      localStorage.setItem(key, timestamp)
      Vue.$postMessage.saveStorage({ key, payload: timestamp })
    }
  }
}
